import React from 'react';

/**
 * Compact "2D / 45° / 360°" segmented switcher that lives next to the
 * SATELLITE/HYBRID/ROADMAP/TERRAIN row at the bottom of the map.
 *
 *  - 2D   : top-down view (tilt 0). Default.
 *  - 45°  : Google's bird's-eye / oblique satellite — only renders when on
 *           the satellite or hybrid base map AND zoomed in enough; we still
 *           expose the button on all base maps because the SDK silently
 *           ignores the tilt request otherwise (no harm).
 *  - 360° : opens the Street View panorama modal at the current map center.
 *
 * No tier gating — feature is free for everyone (Google quota covers our
 * volume). Disabled state only applies when the map isn't ready yet.
 */
const VIEW_MODES = [
  { id: '2d', label: '2D', title: 'Top-down satellite view' },
  { id: '45', label: '45°', title: "Bird's-eye / oblique view" },
  { id: '360', label: '360°', title: 'Street View panorama at current location' },
];

export function ViewModePill({ value, disabled, onChange }) {
  return (
    <div className="inline-flex items-center gap-0.5" data-testid="view-mode-pill">
      {VIEW_MODES.map((m) => {
        const active = value === m.id;
        return (
          <button
            key={m.id}
            type="button"
            disabled={disabled}
            onClick={() => onChange?.(m.id)}
            className={`px-2.5 py-1.5 rounded text-xs font-bold uppercase tracking-wider transition-all ${
              active
                ? 'bg-primary text-white'
                : 'hover:bg-gray-100 dark:hover:bg-white/10 opacity-70 hover:opacity-100'
            } disabled:opacity-40 disabled:cursor-not-allowed`}
            title={m.title}
            aria-pressed={active}
            data-testid={`view-mode-${m.id}`}
          >
            {m.label}
          </button>
        );
      })}
    </div>
  );
}
